import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { getTeams } from "../../actions/userActions/teamAction";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { SIZE_OF_PAGE } from "../../actions/types";
import DynamicTable from "../reuse_components/DynamicTable";
import CustomButton from "../subComponents/buttons/CustomButton";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import Heading6Regular from "../designSystem/Heading6Regular";
import SearchInput from "../subComponents/search/SearchInput";
import { Download } from "lucide-react";
import { IconButton } from "@mui/material";
import { downloadTeam } from "../../actions/userActions/teamAction";
import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import CustomPagination from "../subComponents/pagination/CustomPagination";
import AddTeams from "./AddTeams";
import ItemsPerPageSelector from "../subComponents/pagination/ItemsPerPageSelector";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay"
import { t } from "../../locales/translate";

function Teams() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1)
  const [previousQuery, setPreviousQuery] = useState("");
  const [query, setQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [teamdata, setteamdata] = useState([]);
  const teams = useSelector((state) => state.teams_reducer.teams);
  const teamsData = teams && teams.result;
  const totalPages = teams?.totalPages || 0;
  const totalItems = teams?.totalCount || 0;
  const firstPage = 1;
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const permissions = JSON.parse(localStorage.getItem("permissionsList"));
  const isLoading= useSelector((state) => state.teams_reducer.isTeamsLoading)
  useEffect(() => {
    const pageNumber = currentPage;
  
      if (query !== previousQuery) {
        setCurrentPage(1);
      }
      dispatch(getTeams(pageNumber, itemsPerPage, query));
      setPreviousQuery(query);
  
    }, [currentPage, query]);
  useEffect(() => {
  
    const teamData = teams && teamsData;
    const TeamData = teamData?.map((teams) => ({
      ...teams,
      status: (
        <span className={teams.active ? "status-badge-active" : "status-badge-inactive"}>
          {teams.active ? "Active" : "Inactive"}
        </span>
      ),
    }));
    setteamdata(TeamData);
  }, [teams]);

  const columns = [
    { label: `${t("name")}`, accessor: "name" },
    { label: `${t("description")}`, accessor: "description" },
     { label: `${t("status")}`, accessor: "status" },  
  ];
  
  const handleAddTeamClick = () => {
    setEditData(null);
    setShowModal(true);
  };

  const handleEditTeam = (row) => {
    setEditData(row);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleSaveData = async () => {
    dispatch(getTeams(currentPage, itemsPerPage, query));
    setShowModal(false);
  };
  const actions = [  
    {
        label: 'Edit Team',
        icon: <EditOutlinedIcon sx={{ color: '#0438B4' }}/>,
        permission: 'CanUpdateTeam',
        handler:handleEditTeam,
    },
  ];
  const handleItemsPerPageChange = (value) => {
    const pageNumber = firstPage;
    dispatch(getTeams(pageNumber, value, query));
    setItemsPerPage(value);
    setCurrentPage(1);
  };
  const handleSearchChange = (e) => {
    setQuery(e.target.value);
    setCurrentPage(1);
  };
  const handleTeamDownload = () => {
  dispatch(downloadTeam());
};
  return (
    <>
      <div>
        <LoadingOverlay isVisible={isLoading} />
        <div className="main-container">
         <div className="content-wrapper">
            <div className="pagination">
              <SearchInput
                placeholder="Search"
                onChange={handleSearchChange}
                value={query}
              />
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ minWidth: '80px', marginRight: '10px' }}>
                  <ItemsPerPageSelector
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  />
                </div>
                <CustomPagination
                  currentPage={currentPage}
                  totalItems={totalItems}
                  itemsPerPage={itemsPerPage}
                  totalPages={totalPages}
                  onPageChange={(page) => setCurrentPage(page)}
                />
                <div style={{ paddingRight: '12px' }}>
                  <IconButton onClick={handleTeamDownload}>
                    <Download />
                  </IconButton>
                </div>
                {permissions && permissions.includes("CanAddTeam") && (
                  <CustomButton text={t("addNew")} onClick={handleAddTeamClick} />
                )}
              </div>
            </div>
            </div>
            <DynamicTable
              data={teamdata}
              columns={columns}
              permissions={permissions}
              actions={actions}
              thIcon={thIcon}
              showPagination={totalItems > 0}
              currentPage={currentPage}
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              totalPages={totalPages}
              onPageChange={(page) => setCurrentPage(page)}
              onItemsPerPageChange={handleItemsPerPageChange}
            />
         
        </div>
        {showModal && (
        <AddTeams
          onClose={handleCloseModal}
          editData={editData}
          onSave={handleSaveData}
        />
      )}
      </div>
   
    </>
  );
}

export default Teams;
